import React, { useState } from 'react';
import type { Image } from '../types';
import './ImageGallery.css';

interface ImageGalleryProps {
  images: Image[];
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);

  if (images.length === 0) {
    return (
      <div className="image-gallery">
        <div className="main-image placeholder">
          <span>No images available</span>
        </div>
      </div>
    );
  }

  return (
    <div className="image-gallery">
      <div 
        className={`main-image-container ${isZoomed ? 'zoomed' : ''}`}
        onClick={() => setIsZoomed(!isZoomed)}
      >
        <img
          src={images[selectedIndex].url}
          alt={images[selectedIndex].alt}
          className="main-image"
        />
        {isZoomed && (
          <div className="zoom-instructions">Click to exit zoom</div>
        )}
        {!isZoomed && images.length > 1 && (
          <>
            <button 
              className="nav-button prev"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
              }}
              disabled={images.length <= 1}
            >
              ‹
            </button>
            <button 
              className="nav-button next"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
              }}
              disabled={images.length <= 1}
            >
              ›
            </button>
          </>
        )}
      </div>

      {images.length > 1 && (
        <div className="thumbnail-container">
          <div className="thumbnails">
            {images.map((image, index) => (
              <div 
                key={image.id}
                className={`thumbnail ${index === selectedIndex ? 'selected' : ''}`}
                onClick={() => setSelectedIndex(index)}
              >
                <img src={image.url} alt={image.alt} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery; 